var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeverityIconsBackgroundError24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 27,
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Property 1=Failed (red x), SIze=24, Type=Fill and bg",
    filter: "url(#filter0_d_24505_201696)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 24,
    height: 24,
    rx: 6,
    fill: "#F00707",
    fillOpacity: 0.08,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 5.5C8.58172 5.5 5 9.08172 5 13.5C5 17.9183 8.58172 21.5 13 21.5C17.4183 21.5 21 17.9183 21 13.5C21 11.3783 20.1571 9.34344 18.6569 7.84315C17.1566 6.34285 15.1217 5.5 13 5.5ZM10.6869 10.5136C10.4916 10.3184 10.175 10.3184 9.97978 10.5136C9.78452 10.7089 9.78452 11.0255 9.97978 11.2207L12.2929 13.5339L9.97978 15.847C9.78452 16.0422 9.78452 16.3588 9.97978 16.5541C10.175 16.7493 10.4916 16.7493 10.6869 16.5541L13 14.241L15.3131 16.5541C15.5084 16.7493 15.825 16.7493 16.0202 16.5541C16.2155 16.3588 16.2155 16.0422 16.0202 15.847L13.7071 13.5339L16.0202 11.2207C16.2155 11.0255 16.2155 10.7089 16.0202 10.5136C15.825 10.3184 15.5084 10.3184 15.3131 10.5136L13 12.8267L10.6869 10.5136Z",
    fill: "#F00707"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_24505_201696",
    x: 0,
    y: 0.5,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.941176 0 0 0 0 0.027451 0 0 0 0 0.027451 0 0 0 0.48 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_24505_201696"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_24505_201696",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeverityIconsBackgroundError24);
export default __webpack_public_path__ + "static/media/severity-icons-background-error-24.d19c86552ca6ff5f2759fb02937d1182.svg";
export { ForwardRef as ReactComponent };